import { render, staticRenderFns } from "./LinkUpload.vue?vue&type=template&id=94494d68&"
import script from "./LinkUpload.vue?vue&type=script&lang=js&"
export * from "./LinkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports